import { render, staticRenderFns } from "./McDialog.vue?vue&type=template&id=791c408a&"
import script from "./McDialog.vue?vue&type=script&lang=js&"
export * from "./McDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "McDialog.vue"
export default component.exports